import { AppButton, AppPrimaryButton, AppSecondaryButton } from 'elements'
import React, { useState, useEffect } from 'react'
import { Modal, Button, Popup, Form, TextArea } from 'semantic-ui-react'
import styled from 'styled-components'
import { FlexRow, FlexRowBetween } from './Common'
import { DesktopMode, MobileMode } from 'layout'
import { Download, PencilSimple, Trash, Plus, List, X } from 'phosphor-react'
import { useNavigate } from 'react-router-dom'
import { yupResolver } from '@hookform/resolvers/yup'
import { Controller, useForm } from 'react-hook-form'
import * as yup from 'yup'
import { DangerText } from 'components'
import { AuthService } from 'utility/services/auth'

const DangerButtonContainer = styled.span`
    .button {
        background: ${({ theme }) => theme.colors.danger} !important;
        color: ${({ theme }) => theme.colors.white} !important;
    }
`

export const AppButtonPopup = ({
    children,
    on = 'click',
    buttonText = '',
    triggerItem = false,
    className,
    position = 'bottom center',
    onClose,
    ...rest
}) => {
    return (
        <Popup
            content={() => children}
            on={on}
            closeOnPortalMouseLeave
            pinned
            className={className}
            position={position}
            trigger={
                triggerItem ? (
                    <div style={{ display: 'inline-block' }}>{triggerItem}</div>
                ) : (
                    <AppButton>{buttonText}</AppButton>
                )
            }
            onClose={onClose}
            {...rest}
        />
    )
}
export const RejectModal = ({
    open,
    onClose,
    onSubmit,
    loading = false,
}) => {
    const [comment, setComment] = useState('')
    const [error, setError] = useState('')

    useEffect(() => {
        if (open) {
            setComment('')
            setError('')
        }
    }, [open])

    const handleClose = () => {
        if (loading) return
        setComment('')
        setError('')
        onClose()
    }

    const handleSubmit = () => {
        if (loading) return
        const reason = comment.trim()
        if (!reason) {
            setError('Rejection reason is required')
            return
        }
        setError('')
        onSubmit(reason)
    }

    return (
        <Modal
            open={open}
            onClose={handleClose}
            size="tiny"
            className="model"
            closeOnDimmerClick={!loading}
            closeOnEscape={!loading}
        >
            <Modal.Header>
                <FlexRowBetween>
                    <span>Reject</span>
                    <X
                        className="pointer"
                        size={32}
                        onClick={handleClose}
                    />
                </FlexRowBetween>
            </Modal.Header>
            <Modal.Content>
                <Form>
                    <Form.Field error={!!error}>
                        <label>Rejection reason</label>
                        <TextArea
                            placeholder="Enter rejection reason..."
                            value={comment}
                            onChange={e => {
                                setComment(e.target.value)
                                if (error) setError('')
                            }}
                            rows={3}
                            disabled={loading}
                        />
                        {error && (
                            <div style={{ color: 'red', marginTop: 4 }}>
                                {error}
                            </div>
                        )}
                    </Form.Field>
                </Form>
            </Modal.Content>
            <Modal.Actions>
                <AppButton
                    type="button"
                    onClick={handleClose}
                    disabled={loading}
                >
                    Cancel
                </AppButton>
                <AppPrimaryButton
                    type="button"
                    onClick={handleSubmit}
                    loading={loading}
                    disabled={loading}
                >
                    Submit
                </AppPrimaryButton>
            </Modal.Actions>
        </Modal>
    )
}
export const AppRemoveButtonPopup = ({
    on,
    buttonText,
    className,
    position,
    onConfirm,
    ...rest
}) => {
    const [open, setOpen] = useState(false)
    return (
        <DangerButtonContainer>
            <Popup
                content={() => (
                    <div>
                        <h4>Are you sure to delete this item?</h4>
                        <FlexRow>
                            <AppPrimaryButton
                                fluid
                                onClick={() => {
                                    setOpen(true)
                                    if (onConfirm) {
                                        onConfirm()
                                    }
                                }}
                            >
                                Yes
                            </AppPrimaryButton>
                            <AppSecondaryButton
                                onClick={() => setOpen(false)}
                                fluid
                            >
                                No
                            </AppSecondaryButton>
                        </FlexRow>
                    </div>
                )}
                on={on || 'click'}
                onOpen={() => setOpen(true)}
                open={open}
                onClose={() => setOpen(false)}
                onUnmount={() => setOpen(false)}
                closeOnEscape
                closeOnPortalMouseLeave
                pinned
                className={`${className} customer-popup`}
                position="bottom right"
                trigger={
                    <AppButton>
                        <DesktopMode>
                            <Trash size={15} />
                        </DesktopMode>
                        <MobileMode>
                            <Trash size={15} />
                        </MobileMode>
                    </AppButton>
                }
                {...rest}
            />
        </DangerButtonContainer>
    )
}
export const AppRemoveButtonPopupComplete = ({
    on,
    buttonText,
    className,
    position,
    onConfirm,
    ...rest
}) => {
    const [open, setOpen] = useState(false)
    return (
        <DangerButtonContainer>
            <Popup
                content={() => (
                    <div>
                        <h4>Are you sure to delete this item?</h4>
                        <FlexRow>
                            <AppPrimaryButton
                                fluid
                                onClick={() => {
                                    setOpen(true)
                                    if (onConfirm) {
                                        onConfirm()
                                    }
                                }}
                            >
                                Yes
                            </AppPrimaryButton>
                            <AppSecondaryButton
                                onClick={() => setOpen(false)}
                                fluid
                            >
                                No
                            </AppSecondaryButton>
                        </FlexRow>
                    </div>
                )}
                on={on || 'click'}
                onOpen={() => setOpen(true)}
                open={open}
                onClose={() => setOpen(false)}
                onUnmount={() => setOpen(false)}
                closeOnEscape
                closeOnPortalMouseLeave
                pinned
                className={`${className} customer-popup`}
                position="bottom right"
                trigger={
                    <AppButton>
                        <DesktopMode>
                            <Trash size={15} />
                        </DesktopMode>
                        <MobileMode>
                            <Trash size={15} />
                        </MobileMode>
                    </AppButton>
                }
                {...rest}
            />
        </DangerButtonContainer>
    )
}

export const AppEditButton = ({ onClick, link, ...rest }) => {
    const navigate = useNavigate()
    const onEdit = () => {
        if (link) {
            navigate(link)
        } else {
            onClick()
        }
    }
    return (
        <span>
            <AppPrimaryButton type="button" onClick={onEdit} {...rest}>
                <DesktopMode>
                    <PencilSimple size={15} />
                </DesktopMode>
                <MobileMode>
                    <PencilSimple size={15} />
                </MobileMode>
            </AppPrimaryButton>
        </span>
    )
}
export const AddToLibraryButton = ({ onClick, link, ...rest }) => {
    const navigate = useNavigate()
    const onEdit = () => {
        if (link) {
            navigate(link)
        } else {
            onClick()
        }
    }
    return (
        <span>
            <AppPrimaryButton type="button" onClick={onEdit} {...rest}>
                <DesktopMode>Add To Library</DesktopMode>
                <MobileMode>
                    <Plus size={15} />
                </MobileMode>
            </AppPrimaryButton>
        </span>
    )
}

export const AppDownloadButton = ({ onClick, text, link, ...rest }) => {
    const navigate = useNavigate()
    const onEdit = () => {
        if (link) {
            navigate(link)
        } else {
            onClick()
        }
    }
    return (
        <span>
            <Button secondary type="button" onClick={onEdit} {...rest}>
                <DesktopMode>{text || 'Download'}</DesktopMode>
                <MobileMode>
                    <Download size={15} />
                </MobileMode>
            </Button>
        </span>
    )
}

export const AppIconButton = ({ onClick, link, text = '', icon, ...rest }) => {
    const navigate = useNavigate()
    const onEdit = () => {
        if (link) {
            navigate(link)
        } else {
            onClick()
        }
    }
    return (
        <span>
            <AppButton type="button" onClick={onEdit} {...rest}>
                <DesktopMode>{text}</DesktopMode>
                <MobileMode>{icon}</MobileMode>
            </AppButton>
        </span>
    )
}
export const AppSetCapaButton = ({ onClick, ...rest }) => {
    return (
        <AppPrimaryButton type="button" onClick={onClick} {...rest}>
            <DesktopMode>Set Capa</DesktopMode>
            <MobileMode>
                <List size={15} />
            </MobileMode>
        </AppPrimaryButton>
    )
}

const schema = yup.object().shape({
    username: yup.string().required('Username is required'),
    password: yup.string().required('Password is required'),
})

export const PublicLoginModal = ({ open, onSuccess, onClose }) => {
    const {
        control,
        handleSubmit,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(schema),
    })

    const [processing, setProcessing] = useState('')
    const [error, setError] = useState('')

    const submit = async formData => {
        try {
            setError('')
            setProcessing('Processing')
            const result = await AuthService.login({
                LoginId: formData.username,
                Password: formData.password,
            })
            const userId = result?.UserId || result?.unique_id || result?.id
            if (result && userId) {
                onSuccess({ ...result, UserId: userId })
            } else {
                setError('Invalid username and/or password')
            }
        } catch (error) {
            setError('Invalid username and/or password')
        } finally {
            setProcessing('')
        }
    }

    return (
        <Modal
            open={open}
            onClose={onClose}
            size="tiny"
            closeOnDimmerClick={false}
            style={{ position: 'fixed', zIndex: 10000 }} // Ensure proper z-index
        >
            <Modal.Header>Login Required</Modal.Header>
            <Modal.Content>
                <Form noValidate onSubmit={handleSubmit(submit)}>
                    <Form.Field>
                        <label>Username</label>
                        <Controller
                            name="username"
                            control={control}
                            render={({ field }) => (
                                <Form.Input
                                    {...field}
                                    placeholder="Username"
                                    autoComplete="username"
                                    error={!!errors?.username}
                                />
                            )}
                        />
                        {errors?.username && (
                            <DangerText>{errors.username.message}</DangerText>
                        )}
                    </Form.Field>
                    <Form.Field>
                        <label>Password</label>
                        <Controller
                            name="password"
                            control={control}
                            render={({ field }) => (
                                <Form.Input
                                    {...field}
                                    type="password"
                                    placeholder="Password"
                                    autoComplete="current-password"
                                    error={!!errors?.password}
                                />
                            )}
                        />
                        {errors?.password && (
                            <DangerText>{errors.password.message}</DangerText>
                        )}
                    </Form.Field>
                    {error && <DangerText>{error}</DangerText>}
                    <Button
                        type="submit"
                        fluid
                        primary
                        loading={!!processing}
                        style={{ marginTop: '1rem' }}
                    >
                        Login
                    </Button>
                </Form>
            </Modal.Content>
            <Modal.Actions>
                <Button onClick={onClose}>Cancel</Button>
            </Modal.Actions>
        </Modal>
    )
}
